import styled from 'styled-components'

export default function DocumentNavigation( { contentBlocks } ) {
  const navLinks = contentBlocks
    .filter( b => b.typeHandle === 'sectionHeading' )
    .map( block => ( {
      id: block.id,
      href: `#${ block.anchorId || block.id }`,
      text: block.sectionTitle,
    } ) )

  return (
    <StyledDocumentNavigation>
      { navLinks.map( link => (
        <a 
          key={ link.id }
          href={ link.href }
        >
          { link.text }
        </a>
      ) ) }
    </StyledDocumentNavigation>
  )
}

const StyledDocumentNavigation = styled.div`
  a {
    display: block;
    padding: 0.25rem 0;
    ${ p => p.theme.typo.mono }
    font-size: ${ p => p.theme.typo.sizes.small };
    line-height: 1.3;
    color: ${ p => p.theme.colors.green400 };
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`
